module.exports = __webpack_public_path__ + "media/images/emblems/Erschwil-blason-af802a5794fe0bfd34342b0e821e0ae4.png";